import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../../../utils/api/base';
import env from '../../../Env';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await post(`${env.baseApiUrl}/api/forgotpassword/request`, {
        emailAddress: email,
      });
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head" />

          {submitted ? (
            <div>
              <p className="text-success">
                If that email address is registered you will receive a reset link shortly.
              </p>
              <div className="account__have-account">
                <Link to="/admin">Back to sign in</Link>
              </div>
            </div>
          ) : (
            <form className="form" onSubmit={handleSubmit}>
              <div className="form__form-group">
                <span className="form__form-group-label">Email address</span>
                <div className="form__form-group-field">
                  <input
                    className="form__field"
                    type="email"
                    name="email"
                    placeholder="admin@llx.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoComplete="username"
                  />
                </div>
              </div>

              {error && (
                <div className="form__form-group">
                  <div className="account__btns">
                    <span className="text-danger">{error}</span>
                  </div>
                </div>
              )}

              <div className="account__btns">
                <button
                  className="account__btn btn btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </div>

              <div className="account__have-account">
                <Link to="/admin">Back to sign in</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
